import React from 'react';

import SweetAlert from './sweet-alert';
import IconClose from './close-icon';
import './style.css';

const Swal = async props => {
	const val = await SweetAlert.fire({
		allowOutsideClick: props.allowOutsideClick !== false,
		backdrop: true,
		background: 'transparent',
		showConfirmButton: false,
		width: props.width,
		html: (
			<div className="landing_popup">
				{/* <span className="close_modal" onClick={SweetAlert.clickCancel}>
					<IconClose />
				</span> */}
				<div className="popup_content">
					{props.title ? <h4 className="title">{props.title}</h4> : null}
					{props.html}
				</div>
			</div>
		),
	});
	return val;
};

export default Swal;
